import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BASE_API_URL } from '@cnt-workspace/data-access';
import { ILogResponse, ILogWhere } from '@curbnturf/entities';
import { objectToUrlParams } from '@curbnturf/helpers';
import { Observable } from 'rxjs';

const API_URL = BASE_API_URL + 'log';

/** Server logs (admin-only on the server). Moved from the app's services/logs.service.ts. */
@Injectable({ providedIn: 'root' })
export class AdminLogApiService {
  private readonly http = inject(HttpClient);

  list(query: ILogWhere): Observable<ILogResponse> {
    // objectToUrlParams only formats Luxon dates; a JS Date would go out as
    // "Wed Oct 21 2026 …", which the server can't read (it then matched nothing).
    const params = {
      ...query,
      createdStart: query.createdStart?.toISOString(),
      createdEnd: query.createdEnd?.toISOString(),
    };
    return this.http.get<ILogResponse>(`${API_URL}?${objectToUrlParams(params, true)}`);
  }
}
